/**
 * Empty the given element
 *
 * @param {Element} Element to empty
 * @returns {Element} The empty element
 */
export function empty(el) {
  while (el.lastChild) {
    el.removeChild(el.lastChild);
  }

  return el;
}
